export default "/images/vendor/flag-icon-css/flags/4x3/uz.svg?6e16292aee6b5262a6938af4ed24792d";